import { useZoneContext } from 'context/ZoneContext';
import { Background, BackgrounsWrappper } from './Backgrounds.styled';

export const Backgrounds = () => {
    const { highestAbsolutePosition, sections, scale, position } = useZoneContext();

    if (!sections.length) {
        return null;
    }

    return (
        <BackgrounsWrappper>
            {sections.map(({ id, min }, index, sections) => {
                const isLastSection = index === sections.length - 1;
                const max = isLastSection ? highestAbsolutePosition.y : sections[index + 1].min;
                return <Background key={id} style={{ height: (max - min) * scale, transform: `translateY(${position.y}px)` }}></Background>;
            })}
        </BackgrounsWrappper>
    );
};
